import React from 'react';

export const STORAGE_NAME = {
    SESSION_VALUES: 'sessionValues',
    DATASET: 'dataset',
    HISTORY: 'history',
    LANGUAGE: 'language',
    OCR: 'ocr'
} as const;